// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__2pXXw","wrapper":"Error_wrapper__v1_1E","content":"Error_content__3sXgl","image":"Error_image__37inl"};